import ConfigForm, { ConfigInput } from "components/Layout/ConfigForm";
import React from "react";

export interface FormDetailsProps {
  handleTaskItemNameChange: (event: any) => void;
  name: string;
}

export default function FormDetails({
  name,
  handleTaskItemNameChange,
}: FormDetailsProps) {
  const inputs: ConfigInput[] = [
    {
      required: true,
      title: "Prompt",
      type: "text",
      onChange: handleTaskItemNameChange,
      xs: 12,
      sm: 6,
      id: "taskItemName",
      value: name,
    },
  ];

  return (
    <ConfigForm title="Configure Form Text Input" inputs={inputs}></ConfigForm>
  );
}
